<flx-resources-grid
  [hasBackground]="false"
  [tableDef]="subprocessesTableCols"
  [items]="items()"
  emptyMsg="No subprocesses found."
/>
